export function inviteToEdit() {
	// noop intentionally blank. Plugin loaded and init via WRM
}

export function inviteToEditWRM() {
	return ['wr!com.atlassian.confluence.plugins.confluence-invite-to-edit:edit-resources'];
}
